<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="ded"><a class="page" id="pv"></a><span class="sm">THIS</span> <span class="sm">BOOK</span> <span class="sm">IS</span> <span class="sm">DEDICATED</span> <span class="sm">TO</span> <span class="sm">JOHN</span> <span class="sm">TRYNESKI,</span> <span class="sm">EXECUTIVE</span> <span class="sm">EDITOR</span> <span class="sm">AT</span> <span class="sm">THE</span> <span class="sm">UNIVERSITY</span> <span class="sm">OF</span> <span class="sm">CHICAGO</span> <span class="sm">PRESS,</span> <span class="sm">WHO</span> <span class="sm">HAS</span> <span class="sm">DEVOTED</span> <span class="sm">HIS</span> <span class="sm">CAREER</span> <span class="sm">TO</span> <span class="sm">CONVERTING</span> <span class="sm">THE</span> <span class="sm">WORDS,</span> <span class="sm">IDEAS,</span> <span class="sm">AND</span> <span class="sm">RESEARCH</span> <span class="sm">OF</span> <span class="sm">SCHOLARS</span> <span class="sm">INTO</span> <span class="sm">KNOWLEDGE</span> <span class="sm">OF</span> <span class="sm">IMPORTANCE.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-druckman-jacobs-0006.vue?216e208b